/* eslint-disable no-console */
import React from 'react';
import styles from './SelectedFacetTerms.module.scss';
import classnames from 'classnames/bind';
import { Icon } from 'gd-design-library';
import { Facet } from '@services';

const cx = classnames.bind(styles);

const CN = 'selected-facet-terms';
const selectedTermClassName = `${CN}__term`;

type TermChangeHandler = (facet: string, term: string) => void;
type ColorChangeHandler = (facet: string, baseColor: string) => void;
type SelectedTerms = Record<string, string[]>;

interface SelectedFacetTermsProps {
  selectedTerms: SelectedTerms;
  facets: Facet[];
  deleteTerm: TermChangeHandler;
  deleteColor: ColorChangeHandler;
}

export const SelectedFacetTerms: React.FC<SelectedFacetTermsProps> = ({
  selectedTerms,
  facets,
  deleteTerm,
  deleteColor
}) => {
  const clickHandler = (facet: string, term: string): void => (
    facet === 'color' ? deleteColor(facet, term) : deleteTerm(facet, term)
  );

  const getDisplayValue = (term: string, value: string): string => {
    // Only attempt JSON parsing if value looks like JSON array
    if (value.startsWith('[')) {
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed) && parsed.length === 2) {
          return `${parsed[0]} - ${parsed[1]}`;
        }
      } catch (error) {
        console.warn('Failed to parse JSON value:', value, error);
      }
    }

    if (term !== 'categories') return value;

    const facet = facets.find(f => f.facet === term);
    if (!facet) return value;

    const { terms } = facet.value;
    for (const t of terms) {
      if ('term' in t && t.term === value) {
        return t.displayTerm || value;
      }
    }

    return value;
  };

  if (Object.values(selectedTerms).every(v => v.length === 0)) return null;

  return (
    <div className={ cx(CN) }>
      { Object.entries(selectedTerms).map(([ term, values ]) =>
        values.map(value => (
          <div
            key={ term }
            className={ cx(selectedTermClassName) }
            onClick={ (): void => clickHandler(term, value) }
          >
            { getDisplayValue(term, value) }
            <Icon
              name='cross'
              width={ 8 }
              height={ 8 }
            />
          </div>
        ))
      ) }
    </div>
  );
};
